import type { FC } from 'react';
import React, { useMemo } from 'react';
import classNames from 'clsx';

import { PlayIcon } from './assets/PlayIcon';
import { PauseIcon } from './assets/PauseIcon';
import classes from './PauseResumeButton.scss';

type PauseResumeButtonState = 'paused' | 'playing';

type PauseResumeButtonProps = {
  className?: string;
  state: PauseResumeButtonState;
  pauseAriaLabel?: string;
  resumeAriaLabel?: string;
  ariaControls?: string;
  onPause?: () => void | Promise<void>;
  onResume?: () => void | Promise<void>;
};

const noop = () => {};

const PauseResumeButton: FC<PauseResumeButtonProps> = ({
  className,
  state,
  pauseAriaLabel,
  resumeAriaLabel,
  ariaControls,
  onPause = noop,
  onResume = noop,
}) => {
  const isPaused = state === 'paused';

  const handleStateChange = useMemo(
    () => (isPaused ? onResume : onPause),
    [isPaused, onResume, onPause],
  );

  return (
    <button
      className={classNames(classes.root, className)}
      type="button"
      aria-label={isPaused ? resumeAriaLabel : pauseAriaLabel}
      aria-pressed={state === 'playing'}
      aria-controls={ariaControls}
      onClick={handleStateChange}
    >
      {isPaused ? <PlayIcon /> : <PauseIcon />}
    </button>
  );
};

export default PauseResumeButton;
